<template>
    <rkm-layout-body title="Lista de aviso">
        <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'painel-senha-aviso-create' })"
                    color="primary"
                >
                    Cadastrar aviso
                </rkm-button>
            </template>
        <rkm-layout-content>
            <List ref="List" />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/painel-senha/aviso/List'

export default {
    components: { List },
}
</script>